import { useLocation, useSearchParams } from 'react-router-dom';
import { useBrandManager } from '@/hooks/useBrandManager';
import { useCookieConsentConfig } from '@/hooks/useCookieConsentConfig';
import { parsePathsSetting, isPathAllowed } from './types';
import { CookieConsentWidget } from './CookieConsentWidget';

/**
 * Renders the cookie consent banner when the cookie-consent plugin is active for the current brand.
 * Brand is resolved from useBrandManager (authenticated) or from URL search param brand_id (embeds/public).
 * Visibility can be limited by plugin settings: enabled_paths (only these paths) and excluded_paths (never these).
 */
export function CookieConsentGlobal() {
  const { currentBrandId } = useBrandManager();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const brandId = currentBrandId || searchParams.get('brand_id') || null;
  const { data: config, isLoading } = useCookieConsentConfig(brandId);

  if (!brandId || !config?.success) return null;

  const settings = config.settings ?? {};
  const enabledPaths = parsePathsSetting(settings.enabled_paths);
  const excludedPaths = parsePathsSetting(settings.excluded_paths);
  if (!isPathAllowed(location.pathname, enabledPaths, excludedPaths)) return null;

  return (
    <CookieConsentWidget
      brandId={brandId}
      config={config}
      isLoading={isLoading}
    />
  );
}
